<template>
    <div class="sticky flex items-center justify-center px-4 py-2 text-center text-slate-900 text-sm top-0 w-full z-50"
         v-bind:style="{ backgroundColor: bannerStore.color }"
         v-if="bannerStore.visible"
    >
        <p class="mx-8">{{ bannerStore.text }}</p>

        <a class="absolute cursor-pointer flex items-center right-4"
           v-bind:title="__('Bezárás')"
           v-on:click="bannerStore.dismiss"
        >
            <c-icon class="h-5 stroke-slate-900 w-5" icon="x" />
        </a>
    </div>
</template>

<script setup lang="ts">
    import { inject } from 'vue';
    import { CIcon } from '@teamfurther/cinderblock';
    import { useBannerStore } from '../stores/banner';

    const __ = inject('__');
    const bannerStore = useBannerStore();
</script>
